import { Guideline } from "./guideline";
import { About } from "./about";
import { VideoTutorials } from "./videoTutorials";
export var LandingPage = function LandingPage() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Guideline, null), /*#__PURE__*/React.createElement(About, null), /*#__PURE__*/React.createElement(VideoTutorials, null));
};